import PropTypes from "prop-types";
import React from "react";
import {
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Table,
  Badge,
} from "reactstrap";

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// i18n
import { withTranslation } from "react-i18next";

const InvoiceDetail = props => {
  document.title = "Admin | Invoice Detail";

  // ================= INVOICE DATA =================
  const invoice = {
    invoiceNo: "INV-1001",
    status: "Paid", // Paid | Unpaid | Overdue
    issueDate: "10 Jan 2025",
    dueDate: "15 Jan 2025",

    client: {
      name: "ABC Realty",
      address: "Toronto, Canada",
      email: "info@abcrealty.com",
      phone: "+1 555 123 4567",
    },

    items: [
      {
        id: 1,
        description: "Annual Subscription – Professional Plan",
        qty: 1,
        price: 999,
      },
      {
        id: 2,
        description: "Additional User License",
        qty: 2,
        price: 50,
      },
    ],

    subtotal: 1099,
    tax: 99,
    total: 1198,

    payment: {
      method: "Stripe",
      transactionId: "pi_3Nabcd12345",
      paidOn: "10 Jan 2025",
    },
  };

  const statusColor = {
    Paid: "success",
    Unpaid: "warning",
    Overdue: "danger",
  };

  // ================= UI =================
  return (
    <div className="page-content">
      <Container fluid>

        <Breadcrumbs
          title={props.t("Billing")}
          breadcrumbItem={props.t("Invoice Detail")}
        />

        {/* ================= HEADER ================= */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0">
            Invoice #{invoice.invoiceNo}
          </h4>

          <div className="d-flex gap-2">
            <Button color="light">Send Email</Button>
            <Button color="light">Download PDF</Button>
            <Button color="primary">Mark as Paid</Button>
          </div>
        </div>

        <Card>
          <CardBody>

            {/* ================= STATUS ================= */}
            <Row className="mb-4">
              <Col md="6">
                <Badge color={statusColor[invoice.status]}>
                  {invoice.status}
                </Badge>
              </Col>
              <Col md="6" className="text-end">
                <p className="mb-1">
                  <strong>Issue Date:</strong>{" "}
                  {invoice.issueDate}
                </p>
                <p className="mb-0">
                  <strong>Due Date:</strong>{" "}
                  {invoice.dueDate}
                </p>
              </Col>
            </Row>

            {/* ================= CLIENT & COMPANY ================= */}
            <Row className="mb-4">
              <Col md="6">
                <h6>From</h6>
                <p className="mb-1 fw-bold">
                  Realty Space CRM
                </p>
                <p className="mb-0 text-muted">
                  Toronto, Canada
                </p>
              </Col>

              <Col md="6" className="text-end">
                <h6>Bill To</h6>
                <p className="mb-1 fw-bold">
                  {invoice.client.name}
                </p>
                <p className="mb-0 text-muted">
                  {invoice.client.address}
                </p>
                <p className="mb-0 text-muted">
                  {invoice.client.email}
                </p>
                <p className="mb-0 text-muted">
                  {invoice.client.phone}
                </p>
              </Col>
            </Row>

            {/* ================= ITEMS ================= */}
            <Table responsive bordered className="mb-4">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Description</th>
                  <th className="text-end">Qty</th>
                  <th className="text-end">Price</th>
                  <th className="text-end">Total</th>
                </tr>
              </thead>
              <tbody>
                {invoice.items.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.description}</td>
                    <td className="text-end">
                      {item.qty}
                    </td>
                    <td className="text-end">
                      ${item.price}
                    </td>
                    <td className="text-end">
                      ${item.qty * item.price}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {/* ================= TOTAL ================= */}
            <Row>
              <Col md="6">
                <h6>Payment Details</h6>
                <p className="mb-1">
                  <strong>Method:</strong>{" "}
                  {invoice.payment.method}
                </p>
                <p className="mb-1">
                  <strong>Transaction ID:</strong>{" "}
                  {invoice.payment.transactionId}
                </p>
                <p className="mb-0">
                  <strong>Paid On:</strong>{" "}
                  {invoice.payment.paidOn}
                </p>
              </Col>

              <Col md="6">
                <Table borderless className="text-end">
                  <tbody>
                    <tr>
                      <td>Subtotal:</td>
                      <td>${invoice.subtotal}</td>
                    </tr>
                    <tr>
                      <td>Tax:</td>
                      <td>${invoice.tax}</td>
                    </tr>
                    <tr className="fw-bold">
                      <td>Total:</td>
                      <td>${invoice.total}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>

          </CardBody>
        </Card>

      </Container>
    </div>
  );
};

InvoiceDetail.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(InvoiceDetail);
